import { useParams } from "react-router";
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { getManagerAndTherapist, getSingleUser, updateManagerAndTherapist, updateTheUser, userImgUplod } from '../Services/Users';
import { getAllTherapist } from "../Services/Therapist";
import { getAllManager } from "../Services/Manager";


const Edit_User = () => {
    // This is for both online and simple users
    const { id } = useParams()

    const Swal = require('sweetalert2')
    const navigate = useNavigate();
    const [loder, setLoder] = useState(false)
    const [scndloder, setScndloder] = useState(false)
    // previous pic
    const [pPicture, setPPicture] = useState()
    // for image
    const [picture, setPicture] = useState(null)
    const [imgData, setImgData] = useState()
    const imagesPreview = (e) => {
        if (e.target.files[0]) {
            setPicture(e.target.files[0])
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[0])
            reader.addEventListener("load", () => {
                setImgData(reader.result)
            })
        }
    }

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = async (fData) => {
        setLoder(true)
        const data = {
            email: fData.email,
            // password: fData.pass,
            fullName: fData.fullName,
            phoneNumber: fData.phoneNumber,
            id: id,
            profilePicture: ""
        }
        // upload img
        if (picture !== null) {
            const formData1 = new FormData();
            formData1.append("", picture);
            const imageResponse = await userImgUplod(formData1);
            data.profilePicture = imageResponse.data.data.url;
        } else {
            data.profilePicture = pPicture;
        }

        const resp = await updateTheUser(data);
        if (resp.data.code === 1) {
            Swal.fire({
                title: resp.data.message,
                timer: 1400,
                icon: 'success',
                showConfirmButton: false,
            })
            setTimeout(() => {
                navigate("/manage-user");
            }, 2000);
        } else {
            Swal.fire({
                title: resp.data.data.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false,
            })
            setLoder(false)
        }
    }

    // get data api
    useEffect(() => {
        getSingleApiFunc()
    }, [])

    const [therapistData, setTherapistData] = useState([])
    const [managerData, setManagerData] = useState([])
    const [managerAndTherapist, setManagerAndTherapist] = useState([])
    const [checkRole, setCheckRole] = useState()

    const getSingleApiFunc = async () => {
        const userResp = await getSingleUser(id);
        setPPicture(userResp?.data?.data?.profilePicture)
        reset(userResp?.data?.data)
        setCheckRole(userResp?.data?.data?.role)
        // if user is Inhouse then below Api's will called 
        if (userResp?.data?.data?.role === "InHouse") {
            // this one for only getting inHouseUserDetailId
            const caseManagerData = await getManagerAndTherapist(id)
            setManagerAndTherapist(caseManagerData?.data?.data)
            // below for dropdowns
            const therpists = await getAllTherapist("")
            setTherapistData(therpists?.data?.data)
            const manager = await getAllManager("")
            setManagerData(manager?.data?.data)
        }
    }


    // update case manager and user func
    const onSubmit2 = async (fData) => {
        // debugger
        if (fData.manager1 !== "()" && fData.therapist1 !== "()") {
            setScndloder(true)
            const data = {
                inHouseUserDetailId: managerAndTherapist.inHouseUserDetailId,
                userId: id,
                caseManagerId: parseInt(fData.manager1),
                therapistId: parseInt(fData.therapist1)
            }
            const resp = await updateManagerAndTherapist(data)
            if (resp.data.code === 1) {
                Swal.fire({
                    title: resp.data.message,
                    timer: 1500,
                    icon: 'success',
                    showConfirmButton: false,
                })
                setTimeout(() => {
                    navigate("/manage-user");
                }, 2000);
            } else {
                Swal.fire({
                    title: resp.data.data.message,
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false,
                })
                setScndloder(true)
            }
        } else {
            // Not changing anything just simply redirecting
            Swal.fire({
                title: "User has been Updated",
                timer: 2000,
                icon: 'success',
                showConfirmButton: false,
            })
            setTimeout(() => {
                navigate("/manage-user");
            }, 2000);
        }
    }


    return (
        <div className="mainDashboard side_dashboard_container">
            <div className="row">
                <div className="col-md-12">
                    <Link to="/manage-user" className="dashboardHeading arrowbefore">
                        <img src="/assets/images/Icon ionic-ios-arrow-back.svg" alt="" />
                        <h2>Edit User</h2>
                    </Link>
                </div>
            </div>
            <div className="users-table set3">
                <div className="users-table-container">
                    <div className="user-table-head">
                        <div className="userHeading">
                            <h2>User Details</h2>
                        </div>
                    </div>
                    <div>
                        {imgData ? <img className='userImgSiZe' src={imgData} alt='' /> :
                            <>
                                <div className='uploadBtnUser1'>
                                    <img className='userImgSiZe' src={pPicture ?? "/assets/images/user Detail Image1.png"} alt="" />
                                    <input onChange={imagesPreview} type="file" accept='image/*' />
                                </div>
                            </>
                        }
                    </div>
                    <form style={{ flexWrap: "wrap" }} className="form-login set2">
                        <div className="therapist_category userImg1 useralignmnt">
                            <input type="text" name="uname" placeholder="Mathew Johnson" {...register("fullName", { required: true })} />
                            <span className="error">{errors.name?.type === 'required' && "This field is required"}</span>
                        </div>
                        <div className="therapist_name userImg2 useralignmnt">
                            <input type="text" name="uname" placeholder="mathewjohnson@gmail.com" {...register("email", { required: true })} />
                            <span className="error">{errors.email?.type === 'required' && "This field is required"}</span>
                        </div>
                        <div className="therapist_category userImg3 useralignmnt">
                            <input type="text" name="uname" placeholder="(859)129-2962" {...register("phoneNumber", { required: true })} />
                            <span className="error">{errors.nmber?.type === 'required' && "This field is required"}</span>
                        </div>
                        {/* <div className="therapist_category userImg4 useralignmnt">
                            <input type="password" name="uname" placeholder="********" {...register("pass")} />
                            <span className="error">{errors.pass?.type === 'required' && "This field is required"}</span>
                        </div> */}
                        <span className="error">{errors.typeOfUser?.passw === 'required' && "Therapist Email is required"}</span>


                    </form>
                </div>
            </div>

            <div className="buttonSet">
                <Link to="/manage-user" className="bttn setb">Cancel</Link>
                {
                    (loder === true) ?
                        <div className="relative">
                            <div className="loader alignAdd userLodrgg"></div>
                            <Link style={{ display: "block" }} to="" className="bttn bttn-bg" >Update</Link>
                        </div>
                        :
                        <Link to="" className="bttn bttn-bg" onClick={handleSubmit(onSubmit)}>Update</Link>
                }
            </div>
            {/* Inhouse user can only have Therapist and Case Manager  */
                checkRole === "InHouse" &&
                <>
                    <form className="users-table set3">
                        <div className="users-table-container">
                            <div className="user-table-head">
                                <h2 style={{ color: "#fff", fontSize: "20px", fontWeight: "500" }}>Therapist and Case Manager</h2>
                            </div>
                            <div className="mlNone">
                                <div className="useralignmnt setDropDwn">
                                    <h3
                                        style={{ color: "white", fontSize: "17px", fontWeight: "unset" }}
                                    >Therapist</h3>
                                    <select className='userOPtion' {...register("therapist1", { required: true })}>
                                        <option
                                            value={managerAndTherapist?.therapistId} selected disabled>
                                            {managerAndTherapist?.therapistName} ({managerAndTherapist?.therapistEmail})
                                        </option>
                                        {
                                            therapistData?.map((item) => {
                                                return <option value={item?.therapistId}>
                                                    {item?.name} ({item.email})
                                                </option>
                                            })
                                        }
                                    </select>
                                    <span className="error errorB">{errors.therapist?.type === 'required' && "This field is required"}</span>
                                </div>
                                <div className="useralignmnt setDropDwn">
                                    <h3
                                        style={{ color: "white", fontSize: "17px", fontWeight: "unset" }}
                                    >Case Manager</h3>
                                    <select className='userOPtion' {...register("manager1", { required: true })}>
                                        <option
                                            value={managerAndTherapist?.caseManagerId}
                                            selected disabled>
                                            {managerAndTherapist?.caseManagerName} ({managerAndTherapist.caseManagerEmail})
                                        </option>
                                        {
                                            managerData?.map((item) => {
                                                return <option value={item?.caseManagerId}>
                                                    {item?.name} ({item.email})
                                                </option>
                                            })
                                        }
                                    </select>
                                    <span className="error errorB">{errors.manager?.type === 'required' && "This field is required"}</span>
                                </div>
                                <div className="useralignmnt setDropDwn" style={{ width: "337px" }}>
                                </div>
                            </div>

                        </div>
                    </form>
                    <div className="buttonSet">
                        {
                            (scndloder === true) ?
                                <div className="relative">
                                    <div className="loader alignAdd userLodrgg"></div>
                                    <Link style={{ display: "block" }} to="" className="bttn bttn-bg" >Update</Link>
                                </div>
                                :
                                <Link to="" className="bttn bttn-bg" onClick={handleSubmit(onSubmit2)}>Update</Link>
                        }
                    </div>
                </>
            }
        </div >
    );
}

export default Edit_User;